/* À utiliser pour des formulaires sans liste (pas de data-iterator)*/
export default {
  data() {
    return {
      valid: false,
    }
  },
  mounted() {
    this.$emit("validation-changed", this.isValid)
  },
  watch: {
    valid() {
      this.$emit("validation-changed", this.valid)
    },
  }
}
